import {MyRecipesDocument, useCreateRecipeMutation, useMyRecipesQuery} from "app/gql/graphqlSchema";
import {Link, useNavigate} from "react-router";
import {TwTable, TwTableBody, TwTableCell, TwTableHead, TwTableHeader, TwTableRow} from "app/components/tw";
import {Button, Tooltip, Typography} from "antd";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import {linkRecipe} from "app/nav/links";
import {assertNotNil} from "app/util/stdlib";
import {Loading} from "app/components/Loading";

export const MyRecipes = () => {
  const navigate = useNavigate();
  const [createRecipe] = useCreateRecipeMutation({
    refetchQueries: [MyRecipesDocument]
  });
  const {data, loading} = useMyRecipesQuery({fetchPolicy: "cache-and-network"});

  if (loading) {
    return <Loading />;
  }

  const handleCreateRecipe = async () => {
    const {data} = await createRecipe({
      variables: {
        input: {
          description: "description",
          name: "name"
        }
      }
    });
    assertNotNil(data?.createRecipe.id);
    navigate(linkRecipe(data.createRecipe.id));
  };

  return (
    <div>
      <Typography.Title>My Recipes</Typography.Title>
      <TwTable>
        <TwTableHead>
          <TwTableHeader>Name</TwTableHeader>
          <TwTableHeader>Description</TwTableHeader>
          <TwTableHeader>Actions</TwTableHeader>
        </TwTableHead>
        <TwTableBody>
          {data?.myRecipies.map((recipe) => (
            <TwTableRow key={recipe.id}>
              <TwTableCell>
                <Tooltip
                  title={
                    <>
                      Edit <strong className="font-bold">{recipe.name}</strong>
                    </>
                  }
                >
                  <Link to={`/my-recipes/${recipe.id}`}>{recipe.name}</Link>
                </Tooltip>
              </TwTableCell>
              <TwTableCell>{recipe.description}</TwTableCell>
              <TwTableCell>
                <Tooltip
                  title={
                    <>
                      Delete <strong className="font-bold">{recipe.name}</strong>
                    </>
                  }
                >
                  <Button color="danger" icon={<DeleteOutlined />} variant="solid" />
                </Tooltip>
              </TwTableCell>
            </TwTableRow>
          ))}
        </TwTableBody>
      </TwTable>
      <Button className="mt-4" icon={<PlusOutlined />} onClick={handleCreateRecipe} type="primary">
        Create Recipe
      </Button>
    </div>
  );
};
